import { render } from "./ModalChangePassword.vue?vue&type=template&id=b3957f62&scoped=true"
import script from "./ModalChangePassword.vue?vue&type=script&lang=js"
export * from "./ModalChangePassword.vue?vue&type=script&lang=js"

import "./ModalChangePassword.vue?vue&type=style&index=0&id=b3957f62&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3957f62"]])

export default __exports__